export const ASSETS = {
  logo: "https://customer-assets.emergentagent.com/job_cultivate-outcomes/artifacts/wg9w2d5f_file_00000000821471fd9b1f3575f52a0245%20%281%29.png",
  hero: "https://customer-assets.emergentagent.com/job_6be4e79f-3163-49c2-832c-bfd62c518344/artifacts/g26r0jab_2Y4A3172.jpg",
  portrait: "https://customer-assets.emergentagent.com/job_6be4e79f-3163-49c2-832c-bfd62c518344/artifacts/8j78bn4y_2Y4A3177.jpg",
  family: "https://customer-assets.emergentagent.com/job_cultivate-outcomes/artifacts/z6t4cppe_Screenshot_20260615_130522_Facebook.jpg",
  classroom: "https://customer-assets.emergentagent.com/job_cultivate-outcomes/artifacts/cu67fqhr_DSC_9142.jpg",
  action1: "https://customer-assets.emergentagent.com/job_6be4e79f-3163-49c2-832c-bfd62c518344/artifacts/g26r0jab_2Y4A3172.jpg",
  action2: "https://customer-assets.emergentagent.com/job_6be4e79f-3163-49c2-832c-bfd62c518344/artifacts/8j78bn4y_2Y4A3177.jpg",
  action3: "https://customer-assets.emergentagent.com/job_6be4e79f-3163-49c2-832c-bfd62c518344/artifacts/8odk7x7k_2Y4A3300.jpg",
  studentAssembly: "https://customer-assets.emergentagent.com/job_cultivate-outcomes/artifacts/5vzmu3a2_DSC_9140.jpg",
  pd: "https://customer-assets.emergentagent.com/job_cultivate-outcomes/artifacts/8ys1itae_IMG_0166.JPG",
  district: "https://customer-assets.emergentagent.com/job_cultivate-outcomes/artifacts/4vba22ex_IMG_9936.jpg",
  parents: "https://customer-assets.emergentagent.com/job_cultivate-outcomes/artifacts/5vzmu3a2_DSC_9140.jpg",
};

export const CALENDLY_URL = "https://calendly.com/cd-cdaughtspeaks";

export const SOCIALS = {
  instagram: "https://www.instagram.com/cdaughtspeaks?igsh=MXFucGg2OW4xeXF5aA==",
  facebook: "https://www.facebook.com/share/1GXaJLhsEi/",
  youtube: "https://youtube.com/@cdaughtspeaks?si=Bam3GRE6Rqa3gXzr",
  linkedin: "https://www.linkedin.com/in/chris-daughtery-7b9679a6?utm_source=share_via&utm_content=profile&utm_medium=member_android",
  email: "info@cdaughtspeaks.com",
};
